import searchOne from "./searchOne.vue";
export default [searchOne];
